import { GridButtons } from "@/controls/buttons/GridButtons";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CatalogSectionFamily } from "../../../models/CatalogSectionFamily";
import ColorCircleRenderer from "@/pages/configuration/delay-categories/components/ColorPicker/ColorCircleRendered";

type Props = {
	setSectionFamilyId: (id: number) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSectionFamilyId,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "SectionFamilyName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "SectionsName",
			headerName: "Sections",
			minWidth: 20,
			flex: 2,
		},
		{
			field: "SectionFamilyColor",
			headerName: "Color",
			sortable: false,
			flex: 1,
			cellRenderer: ColorCircleRenderer,
			minWidth: 130,
		},
		{
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSectionFamilyId,
				id: (params.data as CatalogSectionFamily).SectionFamilyId,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "sectionFamilyContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			minWidth: 200,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
